import { render } from "./VueNotificationListItem.vue?vue&type=template&id=0730d53e&scoped=true"
import script from "./VueNotificationListItem.vue?vue&type=script&lang=ts"
export * from "./VueNotificationListItem.vue?vue&type=script&lang=ts"

import "./VueNotificationListItem.vue?vue&type=style&index=0&id=0730d53e&lang=scss&scoped=true"
import "./VueNotificationListItem.vue?vue&type=style&index=1&id=0730d53e&lang=scss"
script.render = render
script.__scopeId = "data-v-0730d53e"

export default script